import { render, staticRenderFns } from "./close-mini.vue?vue&type=template&id=04fd3cf3&scoped=true&"
var script = {}
import style0 from "./close-mini.vue?vue&type=style&index=0&id=04fd3cf3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd3cf3",
  null
  
)

export default component.exports